import React from "react";

const COMPARE_JUNGLE_CONTENT = [
  [{ textParagraph: "Basic: $49/month ($349/year)" }],
  [{ textParagraph: "Suite: $69/month ($589/year)" }],
  [{ textParagraph: "Professional: $129/month ($999/year)" }]
];
export default COMPARE_JUNGLE_CONTENT;
